import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';
import { ClassRoomsService } from 'src/app/data/services/classroom.service';

@Component({
  selector: 'app-year-select',
  templateUrl: './year-select.component.html',
  styleUrls: ['./year-select.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class YearSelectComponent implements OnInit, OnChanges {
  @Input() idSchool: string = '';
  @Input() selectedYear?: string;
  @Output() selectEvent = new EventEmitter<string>();

  years?: string[];

  constructor(private classroomsService: ClassRoomsService) {}

  async ngOnInit(): Promise<void> {
    await this.getYears();
  }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (changes.selectedYear) {
      this.selectedYear = changes.selectedYear.currentValue;
    }
  }

  reset() {
    this.selectedYear = this.years ? this.years[0] : undefined;
  }

  changeYear(select: string) {
    this.selectedYear = select;
    this.selectEvent.emit(select);
  }

  private async getYears(): Promise<void> {
    const currentYear = new Date().getFullYear().toString();
    try {
      if (this.idSchool) {
        const result = await this.classroomsService
          .getYears({ idSchool: this.idSchool })
          .toPromise();
        if (result && result.length > 0) {
          this.years = result;
          if (!this.selectedYear || !result.includes(this.selectedYear)) {
            const currentYearInSchool = this.years.find(year => year === currentYear);
            this.selectedYear = currentYearInSchool ?? this.years[0];
          }

          this.selectEvent.emit(this.selectedYear);
        }
      }
    } catch (error) {
      console.log(error);

      this.years = [currentYear];
      this.selectedYear = currentYear;

      this.selectEvent.emit(currentYear);
    }
  }

}
